module.exports = __webpack_public_path__ + "static/media/Hero.50f48fd4.png";